import { getEwsRequestString } from 'owa-datetime';
import { isFolderPaused, listViewStore } from 'owa-mail-list-store';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7006 (7,48): Parameter 'folderId' implicitly has an 'any' type.
// @ts-expect-error
export function getInboxPausedDateTimeAsString(folderId) {
    if (isFolderPaused(folderId)) {
        return getEwsRequestString(listViewStore.inboxPausedDateTime);
    }

    return null;
}
